// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_tf-5";
export var filledCircle = "_tf-4";
export var historyEntry = "_tf-3";
export var messageSideLeft = "_tf-1";
export var messageSideRight = "_tf-2";
export var orderTrackingCarouselWrapper = "_tf-6";
export var orderTrackingInfoContainer = "_tf-0";